import { Component, Input, OnInit, signal, WritableSignal } from '@angular/core';

export interface ButtonSwitcherOption {
  label: string;
  value: string | number;
  displayByDefault: boolean;
  click: () => void | Promise<void>;
}

@Component({
  selector: 'pl-button-switcher',
  templateUrl: './buttonSwitcher.component.html',
  styleUrls: ['./buttonSwitcher.component.scss'],
})
export class ButtonSwitcherComponent implements OnInit {
  @Input({ required: true }) public options: ButtonSwitcherOption[] = [];

  public optionSelected: WritableSignal<ButtonSwitcherOption | undefined> = signal(undefined);

  private disableButtonWhileClickFnInProgress: boolean = false;

  public ngOnInit(): void {
    const optionSelected: ButtonSwitcherOption =
      this.options.find((option: ButtonSwitcherOption) => option.displayByDefault) || this.options[0];

    this.optionSelected.set(optionSelected);
  }

  public async onButtonClicked(): Promise<void> {
    const optionSelected: ButtonSwitcherOption | undefined = this.optionSelected();
    if (optionSelected && !this.disableButtonWhileClickFnInProgress) {
      this.disableButtonWhileClickFnInProgress = true;
      for (let i: number = 0; i < this.options.length; i++) {
        const currentOption: ButtonSwitcherOption = this.options[i];
        if (currentOption.value === optionSelected.value) {
          const indexNextOption: number = i === this.options.length - 1 ? 0 : i + 1;
          const nextOption: ButtonSwitcherOption = this.options[indexNextOption];
          this.optionSelected.set(nextOption);
          await nextOption.click();
          this.disableButtonWhileClickFnInProgress = false;
          return;
        }
      }
    }
  }
}
